import React from 'react';
import {Confirm, Table, TableBody, TableBodyCell, TableBodyRow,} from "@tag/tag-components-react-v4";
import {EnvironmentTemplate} from "../types/EnvironmentTemplate";
import CountryService from "../services/CountryService";
import CustomerService from "../services/CustomerService";

function ConfirmDetails(props: { visible: boolean, setVisible: Function, createEnvironmentFn: Function, chosenTemplate: EnvironmentTemplate, customerName: string, locationId: number }) {

    return (
        <>
            <Confirm
                visible={props.visible}
                type="information"
                heading="Confirm"
                onPrimaryButtonClick={() => {
                    props.setVisible(false);
                    props.createEnvironmentFn(props.customerName, props.locationId, props.chosenTemplate.type);
                }}
                onCancelButtonClick={() => {
                    props.setVisible(false);
                }}
                onClose={() => {
                    props.setVisible(false);
                }}
            >
                Please check the following details carefully before confirming: <br /><br />
                <Table>
                    <TableBody>
                        <TableBodyRow>
                            <TableBodyCell style={{fontWeight: 'bold'}}>Customer Name</TableBodyCell>
                            <TableBodyCell style={{textAlign: 'right'}}>{CustomerService.getCustomerNameFromCustomerNamingConvention(props.chosenTemplate.companyNamingConvention, props.customerName)}</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell style={{fontWeight: 'bold'}}>Create on Environment</TableBodyCell>
                            <TableBodyCell style={{textAlign: 'right'}}>{props.chosenTemplate.createOnServerName}</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell style={{fontWeight: 'bold'}}>Country</TableBodyCell>
                            <TableBodyCell style={{textAlign: 'right'}}>{CountryService.getDisplayNameById(props.locationId)}</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow style={{backgroundColor: 'lightgrey'}}>
                            <TableBodyCell style={{fontWeight: 'bold'}}>Template Name</TableBodyCell>
                            <TableBodyCell style={{textAlign: 'right'}}>{props.chosenTemplate.templateName}</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow style={{backgroundColor: 'lightgrey'}}>
                            <TableBodyCell style={{fontWeight: 'bold'}}>Template Customer</TableBodyCell>
                            <TableBodyCell style={{textAlign: 'right'}}>{props.chosenTemplate.templateCustomerName} ({props.chosenTemplate.templateCustomerId})</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow style={{backgroundColor: 'lightgrey'}}>
                            <TableBodyCell style={{fontWeight: 'bold'}}>Template Environment</TableBodyCell>
                            <TableBodyCell style={{textAlign: 'right'}}>{props.chosenTemplate.templateServerName}</TableBodyCell>
                        </TableBodyRow>
                    </TableBody>
                </Table>
            </Confirm>
        </>
    );
}

export default ConfirmDetails;
